<!--
 * @Author: your name
 * @Date: 2020-08-13 16:31:46
 * @LastEditTime: 2022-12-07 10:44:34
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay-ment/index.vue
-->
<style scoped lang="sass">
.choosed
  background-color: rgba(var(--menu-primary-background-colour-rgb), 0.1)

.amount_pay
  padding-left: 17PX
  color: var(--menu-primary-text-colour) !important

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)

.footer_common
  position: fixed
  bottom: 0

// 多版本菜单 B6（U-B6-2 review 第 2 轮 G12）：菜单预览时结账按钮旁那行原因贴着本页的底栏（footer-common 是 56px 高；
// 全局样式 style/index.sass 按两个购物车 58px 的 footer-bar 放），不留 2px 缝
.preview_order_reason
  bottom: 56px

.input_price
  margin-bottom: 30PX
  padding: 0 16PX

  ::v-deep
    .van-cell
      padding: 0

      .van-field__body
        padding-bottom: 6PX
        flex: 1

        &:before
          color: rgba(51, 68, 85, .5)

.icon_container_box
  display: flex
  flex-direction: column
  align-items: center

  .icon_container
    display: flex
    justify-content: center
    align-items: center
    margin: 25px 0
    border-radius: 50%

  .icon_container_text
    margin-bottom: 20px
    width: 264px
    font-size: 16px
    line-height: 16px
    text-align: center
    color: #334455

.icon
  height: 67px

.input_price_amount
  height: 100%
  width: 100%
  border: 1px solid #d2d3d4
  padding-left: 30PX
  font-size: 22PX
  border-radius: 5PX

.input_container
  position: relative
  display: flex
  justify-content: center
  align-items: center
  height: 52PX
  width: 122PX
  margin: auto

.prefix
  position: absolute
  left: 10PX
  top: 50%
  transform: translateY(-50%)
  z-index: 1
  color: var(--menu-primary-text-colour)

::v-deep
  .van-cell__value
    display: flex
    align-items: center

  .van-field__control
    color: var(--menu-primary-text-colour) !important

.show_title
  margin-top: 28PX
  line-height: 19PX
  font-size: 16PX
  color: var(--menu-primary-text-colour)

::v-deep
  .van-field__error-message
    position: absolute
    bottom: -25PX
    left: 78PX
    transform: translateX(-50%)
    display: inline-block
    width: auto
    white-space: nowrap

  .van-cell
    overflow: visible

.tip
  display: flex
  justify-content: center
  align-items: flex-start
  flex-direction: column
  margin-top: 25PX
  padding: 12PX 12PX 12PX 17px
  line-height: 16px
  font-size: 12px
  color: var(--menu-primary-text-colour)
  background-color: #f9f9f9

.prompt_text
  line-height: 16px
  font-size: 12px
  color: var(--menu-primary-text-colour)
  /*background-color: #f9f9f9*/
  padding: 0 16PX

  ol
    padding: 10px 16px

    li
      margin-bottom: 5px
      list-style: decimal
</style>

<template lang="pug">
.payment
  .overflow_scroll
    div(id="container")
    .top
      van-form.form(ref="form")
        .prompt_text(v-if="showInputPrice")
          .show_title.b Setting up your tab is easy!
          ol
            li Set your limit. This is the amount you and your party can't exceed. You will only be charged what you and your party spend (min. tab charge is $1.00).
            li Pre-authorise your tab limit by selecting how you will pay for your tab below.
            li Share your tab with your party (if you want).

        .input_price(v-if="showInputPrice")
          .show_title.b Set your tab limit
          input-field(
            v-model="realPrice"
            name="Tab limit"
            type="number"
            :rules="priceRules"
            dollarIcon
          )
          .show_title.b Please select a payment method to use as security for your tab
        .icon_container_box(v-else)
          .icon_container
            img.icon(:src="paymentsSrc")
          .icon_container_text.b Please select a payment method to use as security for your tab.
      EachPayment.p(
        v-for="(item, i) in srcList"
        v-if="!item.unShow"
        :key="item.id"
        :src="item.pic"
        :name="item.name"
        :choosed="i === index"
        :class="{ 'choosed': i === index }"
        @clickItem="choose(i)"
      )
      #payment-request-button
    .tip.o75
      div(v-if="!showInputPrice") We will charge $1 to this card now. This will be deducted from the tab amount charged, once your tab is closed (min. tab charge is $1).
  //- 多版本菜单 B6（U-B6-3，owner D56 / D98②）：菜单预览页不能开挂账 —— 按钮变灰，旁边说为什么
  .preview_order_reason(v-if="previewOrderBlocked" role="status") {{ previewOrderReason }}
  footer-common.footer_common(@clickButton="validateForm" :text="payButtonText" :disabled="previewOrderBlocked")
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import EachPayment from './component/EachPayment'
import InputField from '../../tab-admin/components/input-field'
import {
  addOrder,
  payOrder,
  getProductList,
  getOrder,
  getUserOrders,
  updateOrder,
  getUser,
  createStripePaymentIntent
} from 'api/product'
import {
  updateTab
} from 'api/tab'
import axios from 'axios'
import dayjs from 'dayjs'
import { mapState } from 'vuex'
import {
  _generateUuidOrderId
} from 'utils/uuid'
import { _getUserChoosedProductListFromBackend } from 'utils/product'
import { isIOS, isAndroid } from '@/utils/navigator'
import { orderAmountNow } from '@/utils/surchargeSnapshot'
import { withOrderMenu } from '@/utils/menu/qrMenu'
import { menuEntry } from '@/utils/menu/qrEntry'
import { isOrderingBlockedByPreview, stopOrderingForPreview } from '@/utils/menu/previewOrderBlock'
import { previewOrdersDisabledText } from '@/utils/menu/previewMenuCopy'
// 注释加载 stripe
// import { loadStripe } from '@stripe/stripe-js'

const baseRequest = {
  apiVersion: 2,
  apiVersionMinor: 0
}
const allowedCardNetworks = ['JCB', 'MASTERCARD', 'VISA']
const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS']
const tokenizationSpecification = {
  type: 'PAYMENT_GATEWAY',
  parameters: {
    gateway: 'fatzebra', // 此为我方使用的 gateway
    gatewayMerchantId: 's2p-mondoconnex-2d328b68d524d6c1' // 此为我方使用的 id
  }
}
const baseCardPaymentMethod = {
  type: 'CARD',
  parameters: {
    allowedAuthMethods: allowedCardAuthMethods,
    allowedCardNetworks: allowedCardNetworks
  }
}
const cardPaymentMethod = Object.assign({},
  baseCardPaymentMethod, {
    tokenizationSpecification: tokenizationSpecification
  }
)
let paymentsClient = null

function getGoogleIsReadyToPayRequest() {
  return Object.assign({},
    baseRequest, {
      allowedPaymentMethods: [baseCardPaymentMethod]
    }
  )
}

function getGooglePaymentDataRequest() {
  const paymentDataRequest = Object.assign({}, baseRequest)
  paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod]
  paymentDataRequest.transactionInfo = getGoogleTransactionInfo()
  paymentDataRequest.merchantInfo = {
    // @todo a merchant ID is available for a production environment after approval by Google
    // See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist|Integration checklist}
    // merchantId: '01234567890123456789',
    merchantId: 'BCR2DN6TROEPXAT4', // 我方使用的 id
    merchantName: 'Mondo Menu' // menu
  }
  return paymentDataRequest
}

function getGooglePaymentsClient() {
  if (paymentsClient === null) {
    const PRODUCTION_ENV = 'production'
    const currentEnv = process.env.VUE_APP_ENV

    let environment = 'TEST'
    if (currentEnv === PRODUCTION_ENV) {
      environment = 'PRODUCTION'
    }
    console.log('currentGooglePayModel', environment)
    paymentsClient = new window.google.payments.api.PaymentsClient({
      environment: environment
    })
  }
  return paymentsClient
}

async function onGooglePayLoaded() {
  try {
    const paymentsClient = getGooglePaymentsClient()
    const response = await paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
    if (response.result) {
      console.log('可以使用google pay')
      return true
      // @todo prefetch payment data to improve performance after confirming site functionality
      // @todo 后期 product 环境，需要用 prefech 来加快加载速度
      // prefetchGooglePaymentData();
    }
  } catch (error) {
    console.log(error)
  }
}

function getGoogleTransactionInfo(realPrice, orderId) {
  return {
    // 现实的 item 细节，这里只是测试，实际不用加入
    displayItems: [{
      label: 'Subtotal',
      type: 'SUBTOTAL',
      price: String(realPrice),
    }
    ],
    // 从这开始为固定项目
    transactionId: String(orderId), // Order ID
    countryCode: this.$store.state.venueHome.venueCountry.toUpperCase(), // 国家代码
    currencyCode: this.$store.state.currency.toUpperCase(), // 国家货币代码 - 根据 venue 的设定来定
    totalPriceStatus: 'FINAL', // 固定为 final，这样价钱就不会变动
    totalPrice: String(realPrice),
    totalPriceLabel: 'Total'
  }
}

function onOrderGetGoogleTransactionInfo(realPrice) {
  return {
    // 现实的 item 细节，这里只是测试，实际不用加入
    displayItems: [{
      label: 'Subtotal',
      type: 'SUBTOTAL',
      price: String(realPrice),
    }
    ],
    // 从这开始为固定项目
    transactionId: '', // @todo 不知道填什么
    countryCode: this.$store.state.venueHome.venueCountry.toUpperCase(), // 国家代码
    currencyCode: this.$store.state.currency.toUpperCase(), // 国家货币代码 - 根据 venue 的设定来定
    totalPriceStatus: 'FINAL', // 固定为 final，这样价钱就不会变动
    totalPrice: String(realPrice),
    totalPriceLabel: 'Total'
  }
}

function prefetchGooglePaymentData() {
  const paymentDataRequest = getGooglePaymentDataRequest()
  // transactionInfo must be set but does not affect cache
  paymentDataRequest.transactionInfo = {
    totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
    currencyCode: this.$store.state.currency.toUpperCase()
  }
  const paymentsClient = getGooglePaymentsClient()
  paymentsClient.prefetchPaymentData(paymentDataRequest)
}
@Component({
  inject: ['name', 'reload'],

  computed: {
    ...mapState({
      routerInfo: state => state.venueHome.routerInfo,
      enablePaymentGateway: state => state.venueHome?.enablePaymentGateway ?? {},
    }),

    venueId() {
      return this.$store.state.venueId
    },

    // 多版本菜单 B6（U-B6-3）：地址里带着菜单预览码 ⇒ 不能开挂账（依赖 $route，跳转后重算）
    previewOrderBlocked() {
      return isOrderingBlockedByPreview(this.$route)
    },

    previewOrderReason() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return previewOrdersDisabledText()
    },

    paymentType() {
      return this.srcList[this.index].value
    },

    venueName() {
      return this.$store.state.navTitle.venueName
    },

    venueInfoRequestStatus () {
      return this.$store.state.app.request
    },

    // 餐厅设置的是否开启柜台支付
    allowCounterPay() {
      return this.$store.state.app.allowCounterPay
    },

    userId() {
      return localStorage.getItem('userId')
    },

    isFromMenuToStartTab() {
      return this.$store.state.isFromMenuToStartTab && !this.hasOrderInfoInCardDetailPage
    },

    hasOrderInfoInCardDetailPage() {
      return this.$store.state.app.hasOrderInfoInCardDetailPage
    }
  },

  components: {
    EachPayment,
    InputField
  },

  async mounted() {
    this._setDefaultRealPriceAmount()
    await this.beforeMountedFunction()
    const currentEnv = process.env.VUE_APP_ENV
    console.log('currentEnv', currentEnv)

    const restrictShowPayButtonList = [
      'production',
    ]

    // @todo temp to ban applePay and GooglePay at production serve. should be remove after test.
    const BAN_PAYMENT_ENV = {
      BAN_APPLE_PAY_ENV_LIST: [
        'production'
      ],
      BAN_GOOGLE_PAY_ENV_LIST: [
        'production'
      ]
    }

    const enableApplePay = _checkEnablePay(currentEnv, BAN_PAYMENT_ENV.BAN_APPLE_PAY_ENV_LIST, ['19efa4ea-e5b4-4434-8f80-baa837261685'], this.$store.state.venueId)
    const enableGooglePay = _checkEnablePay(currentEnv, BAN_PAYMENT_ENV.BAN_GOOGLE_PAY_ENV_LIST, ['19efa4ea-e5b4-4434-8f80-baa837261685'], this.$store.state.venueId)

    if (restrictShowPayButtonList.includes(currentEnv)) {
      await this.showPayButtonByDepends(enableApplePay, enableGooglePay)
    } else {
      // sureShowPayButtonList
      this.srcList = [
        {
          pic: require('@/assets/pay-methods/creditcard.svg'),
          name: 'Credit Card',
          value: 'creditCard',
          unShow: false
        },
        {
          pic: require('@/assets/pay-methods/new-apple-pay.svg'),
          name: 'Apple Pay',
          value: 'applePay',
          unShow: false
        },
        {
          pic: require('@/assets/pay-methods/new-google-pay.svg'),
          name: 'Google Pay',
          value: 'googlePay',
          unShow: false
        },
      ]
    }
    this.$store.commit('closeLoading')

    // functions
    function _checkEnablePay(currentEnv, banEnvList, allowedVenueList = [], currentVenueId = '') {
      const isEnabledPay = !banEnvList.includes(currentEnv)
      const isAllowedVenue = allowedVenueList.includes(currentVenueId)
      return isEnabledPay || isAllowedVenue
    }

    // TODO 注释 stripe 支付相关代码
    // 判断餐厅是否开启 stripe 支付
    // if (this.enablePaymentGateway.enable && this.enablePaymentGateway.type === 'stripe') {
    //   this.srcList.map(item => {
    //     if (item.value === 'applePay' || item.value === 'googlePay') item.unShow = true
    //   })
    //   this.pcSrcList.map(item => {
    //     if (item.value === 'applePay' || item.value === 'googlePay') item.unShow = true
    //   })
    //   this._getStripeClientSecret()
    //   this._initStripe()
    // }
  }
})

class StartTab extends mixins(mixin) {
  priceRules =[
    { required: true, message: 'Tab limit amount is required' },
    { validator: val => !isNaN(val), message: 'Invaild tab limit' }
  ]

  paymentsSrc = require('@/assets/tab-pics/payments.png')
  introduceInfo = 'We will preauthorise this card for your tab limit amount. You will not be charged until your tab is closed and only for the amount you spend.'
  showInputPrice = false // 为 true 时，菜单创建 tab。为 false 时，支付时创建 tab
  // special for pre-paid order tip paid condition, because post-paid will never add-order, only will get-order.
  prePaidOrderHasPaidTip = false
  // for all tip paid condition
  hasPaidTip = false
  tipAmount = 0
  tipRate = 0
  enableTip = false

  payButtonText = 'NEXT'
  realPrice = 0
  defaultRealPrice = '100'
  createOrderId = ''
  createOrderNo = ''
  orderNo = ''
  orderId = ''
  index = 0
  times = 0
  srcList = [
    {
      pic: require('@/assets/pay-methods/creditcard.svg'),
      name: 'Credit Card',
      value: 'creditCard',
      unShow: false
    },
    {
      pic: require('@/assets/pay-methods/new-apple-pay.svg'),
      name: 'Apple Pay',
      value: 'applePay',
      unShow: true
    },
    {
      pic: require('@/assets/pay-methods/new-google-pay.svg'),
      name: 'Google Pay',
      value: 'googlePay',
      unShow: true
    },
  ]

  clientSecret = '' // Stripe 支付需要的数据
  stripe = null // Stripe 实例

  // 获取 Stripe 的必要参数
  async _getStripeClientSecret() {
    const data = await createStripePaymentIntent({
      id: this.orderId || this.createOrderId,
      type: 'order'
    })
    this.clientSecret = data?.clientSecret ?? ''
  }

  // 注释 stripe 支付相关代码
  // async _initStripe() {
  //   // 设置条纹元素
  //   this.stripe = await loadStripe('pk_test_TYooMQauvdEDq54NiTphI7jx', {
  //     apiVersion: '2020-08-27',
  //   })

  //   // 创建一个 paymentRequest 实例
  //   this.paymentRequest = this.stripe.paymentRequest({
  //     country: 'NZ',
  //     currency: 'nzd',
  //     total: {
  //       label: 'Payment',
  //       amount: this.realPrice,
  //     },
  //     requestPayerName: true,
  //     requestPayerEmail: true,
  //   })

  //   // 创建并挂载 paymentRequestButton
  //   var elements = this.stripe.elements()
  //   var prButton = elements.create('paymentRequestButton', {
  //     paymentRequest: this.paymentRequest,
  //   })

  //   // Check the availability of the Payment Request API first.
  //   this.paymentRequest.canMakePayment().then(function(result) {
  //     if (result) {
  //       prButton.mount('#payment-request-button')
  //       document.getElementById('payment-request-button').style.margin = '10PX 0 0'
  //     } else {
  //       document.getElementById('payment-request-button').style.display = 'none'
  //     }
  //   })
  //   // 监听支付
  //   this._stripeCompletePayment()
  // }

  /**
   * stripe 完成支付
   */
  // 注释 stripe 支付相关代码
  // _stripeCompletePayment() {
  //   const _this = this
  //   _this.paymentRequest.on('paymentmethod', function(ev) {
  //     // Confirm the PaymentIntent without handling potential next actions (yet).
  //     _this.stripe.confirmCardPayment(
  //       _this.clientSecret,
  //       { payment_method: ev.paymentMethod.id },
  //       { handleActions: false }
  //     ).then(function(confirmResult) {
  //       if (confirmResult.error) {
  //         // Report to the browser that the payment failed, prompting it to
  //         // re-show the payment interface, or show an error message and close
  //         // the payment interface.
  //         ev.complete('fail')
  //       } else {
  //         // Report to the browser that the confirmation was successful, prompting
  //         // it to close the browser payment method collection interface.
  //         ev.complete('success')
  //         const payType = confirmResult?.paymentIntent?.payment_method_types[0]
  //         const orderId = _this.orderId || _this.createOrderId
  //         const { id, ...userInfo } = _this.$store.state.contactDetails.user
  //         const data = {
  //           venueId: _this.venueId,
  //           action: 'create',
  //           detail: {
  //             ...userInfo,
  //             paymentDetail: {
  //               type: 'applePay',
  //             },
  //             openDateTime: {
  //               date: dayjs.tz().format('YYYY-MM-DD'),
  //               time: dayjs.tz().format('HH:mm'),
  //             },
  //             minAmount: _this.realPrice,
  //             tabAmount: _this.realPrice,
  //           },
  //           userId: localStorage.getItem('userId'),
  //         }
  //         if (payType === 'applePay') {
  //           _this.applePayCreateTab(data)
  //         } else if (payType === 'googlePay') {
  //           _this.googlePayCreateTab({ orderId, token: '' })
  //         }
  //         // Check if the PaymentIntent requires any actions and if so let Stripe.js
  //         // handle the flow. If using an API version older than "2019-02-11"
  //         // instead check for: `paymentIntent.status === "requires_source_action"`.
  //         if (confirmResult.paymentIntent.status === 'requires_action') {
  //           // Let Stripe.js handle the rest of the payment flow.
  //           _this.stripe.confirmCardPayment(_this.clientSecret).then(function(result) {
  //             if (result.error) {
  //               // The payment failed -- ask your customer for a new payment method.
  //             } else {
  //               // The payment has succeeded.
  //               const payType = result?.paymentIntent?.payment_method_types[0]
  //               if (payType === 'applePay') {
  //                 _this.applePayCreateTab(data)
  //               } else if (payType === 'googlePay') {
  //                 _this.googlePayCreateTab({ orderId, token: '' })
  //               }
  //             }
  //           })
  //         } else {
  //           // The payment has succeeded.
  //           if (payType === 'applePay') {
  //             _this.applePayCreateTab(data)
  //           } else if (payType === 'googlePay') {
  //             _this.googlePayCreateTab({ orderId, token: '' })
  //           }
  //         }
  //       }
  //     })
  //   })
  // }

  _setDefaultRealPriceAmount() {
    if (this.isFromMenuToStartTab) this.realPrice = this.defaultRealPrice
  }

  saveTipInfo(tipAmount, enableTip, tipRate) {
    this.$store.commit('saveTipInfo', {
      prop: 'tipAmount',
      val: tipAmount
    })
    this.$store.commit('saveTipInfo', {
      prop: 'enableTip',
      val: enableTip
    })
    this.$store.commit('saveTipInfo', {
      prop: 'tipRate',
      val: tipRate
    })
  }

  // @todo fake api
  async updateOrder() {
    const tipInfo = {
      enableTip: this.enableTip,
      tipAmount: this.tipAmount,
      tipRate: this.tipRate
    }
    const data = {
      details: tipInfo,
      orderId: this.orderId || this.createOrderId,
      userId: localStorage.getItem('userId')
    }
    console.log(data)
    await updateOrder(data).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
  }

  async _filterAndSaveUnfinishOrder() {
    // filter and save unOverOrders
    if (this.userId) {
      await this._updateUnfinishOrders()
    } else {
      this.$store.commit('clearUnpaidOrder', this.venueId)
    }
  }

  async _updateUnfinishOrders() {
    // 未结束的订单列表
    const orders = await this._getUserUnOverOrders('nostart_all')
    const ordersTotal = parseInt(orders.total)
    if (ordersTotal > 0) {
      // 未支付并且未完成的订单列表
      const filtersOrder = orders.orders.filter(item => {
        if (item.paymentStatus === 0 && item.status <= 40) {
          return item
        }
      })
      if (filtersOrder.length > 0) {
        const order = filtersOrder[0]
        // 未付款的 order 的 prePaidOrderHasPaidTip
        this.prePaidOrderHasPaidTip = order.details.enableTip
        this.saveVenueUnpaidOrderList(order.id, order.orderNo)
      } else {
        this.$store.commit('clearUnpaidOrder', this.venueId)
      }
    } else {
      this.$store.commit('clearUnpaidOrder', this.venueId)
    }
  }

  saveVenueUnpaidOrderList(orderId, orderNo) {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: orderId,
      unPaidOrderNo: orderNo,
    })
  }

  async _getUserUnOverOrders(type) {
    const res = await getUserOrders({
      venueId: this.venueId,
      id: this.userId,
      type: type,
      pageSize: 5,
      pageNo: 1
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  async showPayButtonByDepends(enableApplePay, enableGooglePay) {
    if (isIOS() && enableApplePay) {
      await this.startLoadApplePay()
    } else if (isAndroid() && enableGooglePay) {
      await this.startLoadGooglePay()
    } else {
      // 都不显示
      // 是 isAndroid 或者 isIOS，但是都不允许对应的支付
    }
  }

  async startLoadApplePay() {
    const enableShowApplePay = await this.loadApplePay()
    if (enableShowApplePay) {
      // 利用 Array.prototype.splice 的方法避免 Vue 响应式不生效
      this.srcList.splice(1, 1, {
        pic: require('@/assets/pay-methods/new-apple-pay.svg'),
        name: 'Apple Pay',
        value: 'applePay',
        unShow: false
      },)
    }
  }

  async startLoadGooglePay() {
    const enableShowGooglePay = await this.loadGooglePay()
    if (enableShowGooglePay) {
      // 利用 Array.prototype.splice 的方法避免 Vue 响应式不生效
      this.srcList.splice(2, 1, {
        pic: require('@/assets/pay-methods/new-google-pay.svg'),
        name: 'Google Pay',
        value: 'googlePay',
        unShow: false
      },)
    }
  }

  async loadGooglePay() {
  /**
   * 流程解释
   * 1. 这里的 demo 是当 google pay 的 api js 文件读取时候，调用 onGooglePayLoaded
   * 2. 在 onGooglePayLoaded 里，先生成 paymentsClient，然后通过调用 paymentsClient 判断是否可以 google pay
   * 3. 如果可以 google pai，则添加 button 到网页，并且绑定网页。点击：这时候载入订单相关信息，并且调用支付
   * 4. 当支付成功时，生成token（实际是信用卡或者银行卡的加密信息），token 通过 pay-order 传输到后台，由后台进行处理。类似 creditcard
   * 以下具体说明可以参考 google pay 的相关文档：https://developers.google.com/pay/api/web/guides/tutorial
   **/
    console.log('load google pay')
    const res = await onGooglePayLoaded()
    if (res) return true
  }

  onGooglePaymentButtonClicked(realPrice, orderId) {
    console.log('触发click google pay事件')
    const self = this
    const paymentDataRequest = getGooglePaymentDataRequest()
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo(realPrice, orderId)
    console.log(paymentDataRequest)
    const paymentsClient = getGooglePaymentsClient()
    paymentsClient.loadPaymentData(paymentDataRequest)
      .then(function (paymentData) {
      // handle the response
        self.processPayment(paymentData)
      })
      .catch(function (err) {
      // show error in developer console for debugging
        console.error(err)
      })
  }

  _createTabSuccessToJumpToTabMenuPage(currentTabInfo) {
    this._setTabPassCode(currentTabInfo)
    this._jumpToManageTab(currentTabInfo)
  }

  _setTabPassCode(currentTabInfo) {
    const passCode = currentTabInfo.phone.slice(-4)
    this.$store.commit('tabPassCode/SET_TAB_PASS_CODE', passCode)
  }

  _jumpToManageTab(currentTabInfo) {
    this.$router.push({
      path: `/v/${this.venueId}/tab-admin/${currentTabInfo.id}/menu`,
      query: {
        isTabReady: 1
      }
    })
  }

  processPayment(paymentData) {
    const self = this
    self.$store.commit('showLoading')
    // show returned data in developer console for debugging
    console.log(paymentData)
    // @todo pass payment token to your gateway to process payment
    // 拿到 token，现在可以进行下一步 pay-order 了
    const paymentToken = paymentData.paymentMethodData.tokenizationData.token
    self.googlePayCreateTab({
      orderId: self.orderId || self.createOrderId,
      token: paymentToken
    })
  }

  async beforeMountedFunction() {
    this.$store.commit('showLoading')
    if (this.isFromMenuToStartTab) {
      this.showInputPrice = true
    } else {
      await this._filterAndSaveUnfinishOrder()
      this._setShowMask()
      // 获取 OrderId
      await this.getOrderId()
      await this._setOrderPrice()
    }
  }

  async _setOrderPrice() {
    // 获取 order 中的 total price
    const price = await this._getOrderPrice()
    this.realPrice = price
  }

  async _getOrderPrice() {
    const orderId = this.orderId || this.createOrderId
    const res = await getOrder({
      id: orderId
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.hasPaidTip = res.details.enableTip
    const tipAmount = res.tipAmount ? parseFloat(res.tipAmount) : 0
    return res.amount - tipAmount
  }

  // 追加订单 - pre-paid
  async AddOrder(unPaidOrderId) {
    const state = this.$store.state
    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不靠对象字面量里键的先后（review 第 1 轮 #8）
    const amount = orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: state.details,
      type: 0,
      user: {
        ...state.contactDetails.user,
        id: localStorage.getItem('userId'),
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      itemList: this.$store.getters.itemList(this.venueId),
      orderId: unPaidOrderId,
      spDiscounts: state.spDiscounts,
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    if (this.$store.state.cart.includeAlcohol) {
      data.details.over18 = true
    }
    const res = await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route))).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  async getOrderId() {
    // 获取 query 来判断是 paymentType
    this.orderNo = this.$route.query.orderNo
    this.orderId = this.$route.query.orderId

    // 如果是 post-paid
    // 后付款不生成 order，继续传递 orderId 与 orderNo 即可
    if (this.orderNo && this.orderId) {
    } else {
      // pre-paid
      // if the createOrderId and the createOrderNo all exist then didnt create new order
      // 先付款一定生成 order
      let unPaidOrderNo = ''
      let unPaidOrderId = ''
      const index = this.$store.state.venueUnpaidOrderList.findIndex(item => item.venueId === this.venueId)
      if (index !== -1) {
        unPaidOrderNo = this.$store.state.venueUnpaidOrderList[index].unPaidOrderId
        unPaidOrderId = this.$store.state.venueUnpaidOrderList[index].unPaidOrderNo
      }
      if (!unPaidOrderNo) {
        // 如果没有未支付 order，那就 createOrder
        const res = await this.createOrder()
        this.createOrderId = res.id
        this.createOrderNo = res.orderNo
        // this._saveVenueUnpaidOrderList()
      } else {
        // 如果有未支付的 order AddOrder
        if (this.prePaidOrderHasPaidTip) {
          // 如果是未付款，但是已经选择支付 tip 的 order，不再 add-order
          this.createOrderId = unPaidOrderNo
          this.createOrderNo = unPaidOrderId
          return
        }
        const res = await this.AddOrder(unPaidOrderNo)
        this.createOrderId = res.id
        this.createOrderNo = res.orderNo
      }
    }
  }

  _saveVenueUnpaidOrderList() {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: this.createOrderId,
      unPaidOrderNo: this.createOrderNo,
    })
  }

  // 生成 order 后
  _setShowMask() {
    const status = localStorage.getItem('showMask')
    if (!status) localStorage.setItem('showMask', 'show')
  }

  choose (i) {
    this.index = i
    const type = this._getPaymentType(i)
    this._savePaymentType(type)
    this.payButtonText = this._setPayButtonText(type)
  }

  _getPaymentType(index) {
    return this.srcList[index].value
  }

  _setPayButtonText(type) {
    const payTextList = [
      'applePay',
      'googlePay',
    ]
    const PAY_TEXT = 'START TAB & PLACE ORDER'
    const NEXT_TEXT = 'NEXT'
    return payTextList.includes(type) ? PAY_TEXT : NEXT_TEXT
  }

  _savePaymentType(paymentType) {
    this.$store.commit('savePaymentInfo', {
      prop: 'type',
      val: paymentType
    })
  }

  async googlePayCreateTab({ orderId, token }) {
    const self = this
    if (this.showInputPrice) {
      const { id, ...userInfo } = this.$store.state.contactDetails.user
      const data = {
        venueId: this.venueId,
        action: 'create',
        detail: {
          ...userInfo,
          paymentDetail: {
            type: 'googlePay',
            token
          },
          openDateTime: {
            date: dayjs.tz().format('YYYY-MM-DD'),
            time: dayjs.tz().format('HH:mm'),
          },
          minAmount: this.realPrice,
          tabAmount: this.realPrice,
        },
        userId: localStorage.getItem('userId'),
      }
      updateTab(data).catch(error => {
        console.log(error)
        this.$store.commit('closeLoading')
      }).then(res => {
        if (res && res.paymentStatus === 1) {
          console.log('pay-order success')
          // console.log(res)
          self.paySuccess()
        } else {
          console.log('pay-order fail')
          self.payFail()
        }
      })
        .catch(error => {
          console.log('pay-order fail')
          console.log(error)
          self.payFail()
        })
    } else {
      const data = {
        id: orderId,
        paymentInfo: {
          type: 'googlePay',
          action: 'payWithNewTab',
          token
        }
      }
      payOrder(data).catch(error => {
        console.log(error)
        this.$store.commit('closeLoading')
      }).then(res => {
        if (res && res.paymentStatus === 1) {
          console.log('pay-order success')
          // console.log(res)
          self.paySuccess()
        } else {
          console.log('pay-order fail')
          self.payFail()
        }
      })
        .catch(error => {
          console.log('pay-order fail')
          console.log(error)
          self.payFail()
        })
    }
  }

  clearProductListAndUnpaidOrder() {
    this.$store.commit('clearProductList')
    // 与 `tab-user/pay/index.vue:127` 对齐：清车就得连着清折扣，否则存量 `discountAmount`
    // 会在费用链 `_orderFeeChain` 里从下一车扣掉（「小计 − 券」不设下限，空车算出负数）。这里只在
    // `paySuccessJump()` 里调（支付已成功），`state.spDiscounts` 到这一步已经用掉了。
    this.$store.commit('clearDiscounts')
    // this.$store.commit('clearUnpaidOrder', this.venueId)
  }

  async validateForm() {
    // 多版本菜单 B6（U-B6-3，owner D98②）：菜单预览页不能开挂账 / 付款（按钮已变灰；这里兜住按钮状态还没更新的那一下）
    if (stopOrderingForPreview(this.$route)) return
    try {
      await this.$refs.form.validate()
      this.clickButton()
    } catch (error) {
    }
  }

  async clickButton() {
    this.$store.commit('showLoading')
    try {
      if (this.index) {
        let orderId = this.orderId || this.createOrderId
        if (this.showInputPrice) orderId = _generateUuidOrderId()
        if (this.paymentType === 'googlePay') {
          this.onGooglePaymentButtonClicked(String(this.realPrice), orderId)
        } else if (this.paymentType === 'applePay') {
          const applePayRequestInfo = {
            countryCode: this.$store.state.venueHome.venueCountry.toUpperCase(), // 已经同步为 venue country
            currencyCode: this.$store.state.currency.toUpperCase(), // 不是接口获取，而是 vuex 初始化时候写死的
            supportedNetworks: ['visa', 'masterCard'],
            merchantCapabilities: ['supports3DS'],
            total: {
              label: `${this.venueName} - ${orderId}`,
              amount: String(this.realPrice)
            },
          }
          this.startApplePay(applePayRequestInfo, orderId)
        } else if (this.paymentType === 'tabPay') {
          this._jumpToTabPay()
        }
      } else {
        this._saveTabInfo(this.realPrice)
        this._jumpToCardDetail()
      }
      this.$store.commit('closeLoading')
    } catch (error) {
      console.log(error)
      setTimeout(() => {
        this.$store.commit('closeLoading')
      }, 300)
    }
  }

  _saveTabInfo(tabAmount) {
    this.$store.commit('saveTabInfo', {
      prop: 'tabAmount',
      val: parseFloat(tabAmount)
    })
  }

  _jumpToCardDetail() {
    const query = this._getQueryParams()
    this.$router.push({
      path: `/v/${this.venueId}/card-detail`,
      query,
    })
  }

  _getQueryParams() {
    const payOrderQuery = {
      // 区分 pre-paid and post-paid 这就是 post - paid 的 pay 时候，传递过来的 query
      orderNo: this.orderNo,
      orderId: this.orderId,

      // 区分 pre-paid and post-paid 这就是 pre-paid 的情况
      createOrderId: this.createOrderId,
      createOrderNo: this.createOrderNo,
      // 区分 tabPay 的 order
      isTabPay: 1
    }
    const updateTabQuery = {}
    return this.showInputPrice
      ? updateTabQuery
      : payOrderQuery
  }

  _jumpToTabPay() {
    this.$router.push({
      path: `/v/${this.venueId}/tab-user/pay`,
      query: {
        hasPaidTip: this.hasPaidTip,
        orderId: this.orderId || this.createOrderId,
        orderNo: this.orderNo || this.createOrderNo
      }
    })
  }

  /**
   * 创建订单
   * @return {Object} res 订单详情
   */
  async createOrder() {
    const state = this.$store.state
    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不靠对象字面量里键的先后（review 第 1 轮 #8）
    const amount = orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: state.details,
      type: state.type,
      user: {
        ...state.contactDetails.user,
        id: localStorage.getItem('userId'),
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      itemList: this.$store.getters.itemList(this.venueId),
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    if (this.$store.state.cart.includeAlcohol) {
      data.details.over18 = true
    }
    const res = await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route))).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  payFail() {
    console.log('支付失败')
    this.$store.commit('closeLoading')
  }

  async _getUserCurrentTabInfo() {
    const notificationKey = localStorage.getItem('notificationKey') || ''
    const res = await getUser({ id: localStorage.getItem('userId'), notificationKey: notificationKey }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    if (res.currentTab) {
      const currentTab = res.currentTab.find(item => item.venueId === this.$store.state.venueId)
      if (currentTab) {
        return currentTab
      }
    }
    return res.currentTab
  }

  async paySuccess() {
    console.log('支付成功')
    this.$store.commit('closeLoading')
    if (this.showInputPrice) {
      const currentTabInfo = await this._getUserCurrentTabInfo()
      this._createTabSuccessToJumpToTabMenuPage(currentTabInfo)
    } else {
      this.paySuccessJump()
    }
  }

  paySuccessJump() {
    console.log('jump')
    this.clearProductListAndUnpaidOrder()
    if (this.orderNo && this.orderId) {
      this.$router.push({
        path: `/v/${this.venueId}/tab-order-received/${this.orderId}`,
        query: {
          orderNo: this.orderNo,
          isReadyTab: 1
        }
      })
    } else {
      this.$router.push({
        path: `/v/${this.venueId}/tab-order-received/${this.createOrderId}`,
        query: {
          orderNo: this.createOrderNo,
          isReadyTab: 1
        }
      })
    }
  }

  // apple pay

  // 支付函数
  startApplePay(applePayRequestInfo, orderId) {
    console.log('applePayRequestInfo', applePayRequestInfo)
    var currentAvailableApplePayVersion = 3
    for (let i = 3; i <= 10; i++) {
      if (window.ApplePaySession.supportsVersion(i)) {
        currentAvailableApplePayVersion = i
        break
      }
    }
    // 生成 apple pay 请求
    // const request = {
    //   countryCode: 'AU', // country code - 暂定为 au。因为现在只有澳洲，之后应该根据 venue 的设定来拿
    //   currencyCode: 'AUD', // currency code - 暂定为 AUD。因为现在只有澳洲，之后应该根据 venue 的设定来拿
    //   supportedNetworks: ['visa', 'masterCard', 'amex'],
    //   merchantCapabilities: ['supports3DS'],
    //   total: {
    //     label: 'venue name - your order',
    //     amount: '10.00'
    //   },
    // }
    const session = new window.ApplePaySession(currentAvailableApplePayVersion, applePayRequestInfo)
    this._handleApplePayEvents(session, orderId) // 绑定 event 给 apple pay
    session.begin() // 开始
  }

  _handleApplePayEvents(appleSession, orderId) {
    console.log('_handleApplePayEvents')
    const self = this
    // 验证 server 信息
    appleSession.onvalidatemerchant = function (event) {
      const params = {
        id: orderId, // 需要用正确的 order id
        url: event.validationURL,
        tab: true,
        venueId: self.venueId,
        domain: location.host, // 前端 domain
      }
      // 将 params 转换成 query string
      // 从后台申请实际的 session
      axios
        .post(process.env.VUE_APP_BASE_API + '/customer/default/create-safe2way-applepay-intent?' + new URLSearchParams(params).toString())
        .then(res => {
          console.log(res)
          if (res.data.success) {
            // 拿到 session，传回给 apple session，此 session 只能使用一次
            console.log('res success')
            if (res.data.data.merchantSession) {
              console.log('complete merchant')
              appleSession.completeMerchantValidation(res.data.data.merchantSession)
            } else {
              console.log(res.data)
            }
          }
        }).catch(error => console.log('error', error))
    }

    // 当获取付款信息成功后
    appleSession.onpaymentauthorized = function (event) {
      console.log('complete payment')
      if (self.showInputPrice) {
        const { id, ...userInfo } = self.$store.state.contactDetails.user
        const data = {
          venueId: self.venueId,
          action: 'create',
          detail: {
            ...userInfo,
            paymentDetail: {
              type: 'applePay',
              token: event.payment.token
            },
            openDateTime: {
              date: dayjs.tz().format('YYYY-MM-DD'),
              time: dayjs.tz().format('HH:mm'),
            },
            minAmount: self.realPrice,
            tabAmount: self.realPrice,
          },
          userId: localStorage.getItem('userId'),
        }
        self.applePayCreateTab(data, appleSession)
      } else {
        const data = {
          id: orderId, // order id
          paymentInfo: {
            type: 'applePay',
            token: event.payment.token
          }
        }
        self.applePayCreateTab(data, appleSession)
      }
    }
  }

  /**
   * 苹果支付订单
   * @param data {Object} 接口传参
   * @param appleSession {Object} 应用程序会话
   */
  applePayCreateTab(data, appleSession) {
    const self = this
    if (self.showInputPrice) {
      axios
        .post(process.env.VUE_APP_BASE_API + '/customer/default/update-tab', data)
        .then(res => {
          if (res.data.success) {
            // 成功付款
            if (appleSession) appleSession.completePayment(window.ApplePaySession.STATUS_SUCCESS)
            self.paySuccess()
          } else {
            // 未成功付款
            if (appleSession) appleSession.completePayment(window.ApplePaySession.STATUS_FAILURE)
            self.payFail()
          }
        })
    } else {
      axios
        .post(process.env.VUE_APP_BASE_API + '/customer/default/pay-order', data)
        .then(res => {
          if (res.data.success) {
            // 成功付款
            if (appleSession) appleSession.completePayment(window.ApplePaySession.STATUS_SUCCESS)
            self.paySuccess()
          } else {
            // 未成功付款
            if (appleSession) appleSession.completePayment(window.ApplePaySession.STATUS_FAILURE)
            self.payFail()
          }
        })
    }
  }

  async loadApplePay() {
    console.log('loadApplePay')
    const ApplePaySession = window.ApplePaySession
    if (window.ApplePaySession) {
      // 当 apple pay 允许的时候
      // 获得当前最低的 version no，从 3 开始，此处之下的 apple 相关 api 都可以从官网查询内容
      // currentAvailableApplePayVersion 是全局变量，下面需要用到，所以用 var 声明
      var currentAvailableApplePayVersion = 3
      for (let i = 3; i <= 10; i++) {
        if (ApplePaySession.supportsVersion(i)) {
          currentAvailableApplePayVersion = i
          break
        }
      }

      const currentEnv = process.env.VUE_APP_ENV
      const PRODUCTION_ENV = 'production'
      // 显示 apple pay 的 button
      let merchantIdentifier = 'merchant.io.pmnts.sandbox.applepay.dq-mondo'
      if (currentEnv === PRODUCTION_ENV) merchantIdentifier = 'merchant.io.pmnts.production.applepay.s2p-mondoconnex'
      var promise = ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier)
      try {
        const canMakePayments = await promise
        console.log('canMakePayments', canMakePayments)
        if (canMakePayments) {
          // canMakePayments 如果为 true，才显示支付按钮，所以刚开始支付按钮应该隐藏
          return true
        } else {
          console.log('接口没通过验证，不显示apple pay')
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}

export default StartTab
</script>
